import { render } from "./PermissionTest.vue?vue&type=template&id=43b3a794&ts=true"
import script from "./PermissionTest.vue?vue&type=script&lang=ts"
export * from "./PermissionTest.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__